var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 71,
    viewBox: "0 0 128 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.7334 47.1776V54.0015C5.7334 54.636 6.21208 55.1704 6.8466 55.2372L76.7223 61.8607L86.1289 68.0835L99.12 50.8066L5.7334 47.1776Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.29 56.5506V62.6621C59.29 63.1742 59.6574 63.6083 60.1695 63.6862L76.9454 66.3802L76.4556 56.5284L60.4032 55.5042C59.8021 55.4708 59.29 55.9495 59.29 56.5506Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8127 50.3168C12.7571 50.3168 12.7014 50.3168 12.6457 50.3279L11.7552 50.3168V50.7064C10.898 51.3743 10.2969 52.8437 10.2969 54.5581C10.2969 56.328 10.9425 57.8532 11.8554 58.4766V58.7882H12.8016C14.182 58.7882 15.3063 56.8958 15.3063 54.5469C15.3174 52.2203 14.1931 50.3168 12.8127 50.3168Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7547 58.7994C13.138 58.7994 14.2594 56.9005 14.2594 54.5581C14.2594 52.2157 13.138 50.3168 11.7547 50.3168C10.3714 50.3168 9.25 52.2157 9.25 54.5581C9.25 56.9005 10.3714 58.7994 11.7547 58.7994Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8139 54.558C12.8139 55.8716 12.1794 56.9403 11.4001 56.9403C10.6209 56.9403 9.98633 55.8716 9.98633 54.558C9.98633 53.2444 10.6209 52.1758 11.4001 52.1758C12.1794 52.1758 12.8139 53.2444 12.8139 54.558Z",
    fill: "#F9FAFA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8139 54.558C12.8139 55.7826 12.2796 56.7733 11.6228 56.7733C10.966 56.7733 10.4316 55.7826 10.4316 54.558C10.4316 53.3335 10.966 52.3428 11.6228 52.3428C12.2796 52.3539 12.8139 53.3335 12.8139 54.558Z",
    fill: "url(#paint4_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7365 50.7954C18.6697 50.7954 18.6141 50.7954 18.5473 50.8065L17.5788 50.7954L17.5899 51.2184C16.6437 51.9531 15.998 53.5673 15.998 55.4375C15.998 57.3856 16.6993 59.0442 17.7012 59.7344V60.0795H18.7365C20.2505 60.0795 21.4861 57.9978 21.4861 55.4375C21.4861 52.8771 20.2505 50.7954 18.7365 50.7954Z",
    fill: "url(#paint5_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5787 60.0797C19.0973 60.0797 20.3283 58.0014 20.3283 55.4377C20.3283 52.874 19.0973 50.7957 17.5787 50.7957C16.0602 50.7957 14.8291 52.874 14.8291 55.4377C14.8291 58.0014 16.0602 60.0797 17.5787 60.0797Z",
    fill: "url(#paint6_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.189 58.0424C18.0436 58.0424 18.7363 56.8762 18.7363 55.4376C18.7363 53.9989 18.0436 52.8326 17.189 52.8326C16.3344 52.8326 15.6416 53.9989 15.6416 55.4376C15.6416 56.8762 16.3344 58.0424 17.189 58.0424Z",
    fill: "#F9FAFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.422 57.8643C18.1474 57.8643 18.7356 56.7778 18.7356 55.4375C18.7356 54.0973 18.1474 53.0107 17.422 53.0107C16.6965 53.0107 16.1084 54.0973 16.1084 55.4375C16.1084 56.7778 16.6965 57.8643 17.422 57.8643Z",
    fill: "url(#paint7_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0586 50.7954C24.9918 50.7954 24.925 50.7954 24.8582 50.8065L23.8007 50.7954L23.8118 51.2629C22.7877 52.0645 22.0752 53.8233 22.0752 55.8605C22.0752 57.9867 22.8433 59.8012 23.9454 60.5582V60.9367H25.0697C26.7284 60.9367 28.0642 58.6657 28.0642 55.8716C28.0531 53.0663 26.7172 50.7954 25.0586 50.7954Z",
    fill: "url(#paint8_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8011 60.9364C25.455 60.9364 26.7956 58.6687 26.7956 55.8713C26.7956 53.074 25.455 50.8063 23.8011 50.8063C22.1473 50.8063 20.8066 53.074 20.8066 55.8713C20.8066 58.6687 22.1473 60.9364 23.8011 60.9364Z",
    fill: "url(#paint9_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0591 55.8716C25.0591 57.4412 24.3021 58.7214 23.3782 58.7214C22.4431 58.7214 21.6973 57.4412 21.6973 55.8716C21.6973 54.302 22.4542 53.0219 23.3782 53.0219C24.3021 53.0219 25.0591 54.2909 25.0591 55.8716Z",
    fill: "#F9FAFA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0588 55.8717C25.0588 57.33 24.4132 58.5211 23.6339 58.5211C22.8435 58.5211 22.209 57.3411 22.209 55.8717C22.209 54.4023 22.8547 53.2223 23.6339 53.2223C24.4243 53.2223 25.0588 54.4023 25.0588 55.8717Z",
    fill: "url(#paint10_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2142 53.4448C54.1251 53.4448 54.0361 53.456 53.9582 53.456L52.6 53.4448L52.6112 54.046C51.2976 55.0701 50.3848 57.3188 50.3848 59.9237C50.3848 62.6288 51.3644 64.9442 52.767 65.9127L52.7782 66.3914H54.2142C56.3293 66.3914 58.0436 63.4971 58.0436 59.9237C58.0436 56.3392 56.3293 53.4448 54.2142 53.4448Z",
    fill: "url(#paint11_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5999 66.3807C54.7148 66.3807 56.4294 63.485 56.4294 59.913C56.4294 56.341 54.7148 53.4453 52.5999 53.4453C50.485 53.4453 48.7705 56.341 48.7705 59.913C48.7705 63.485 50.485 66.3807 52.5999 66.3807Z",
    fill: "url(#paint12_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0655 63.5527C53.252 63.5527 54.2139 61.9229 54.2139 59.9125C54.2139 57.9021 53.252 56.2723 52.0655 56.2723C50.8789 56.2723 49.917 57.9021 49.917 59.9125C49.917 61.9229 50.8789 63.5527 52.0655 63.5527Z",
    fill: "#F9FAFA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2138 59.9126C54.2138 61.7716 53.4012 63.2856 52.3881 63.2856C51.3751 63.2856 50.5625 61.7716 50.5625 59.9126C50.5625 58.0535 51.3751 56.5396 52.3881 56.5396C53.4012 56.5396 54.2138 58.0535 54.2138 59.9126Z",
    fill: "url(#paint13_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6936 54.4689C79.5823 54.4689 79.471 54.48 79.3597 54.4911L77.6342 54.4689L77.6453 55.2258C75.9644 56.5394 74.8066 59.4004 74.8066 62.7288C74.8066 66.1909 76.0646 69.152 77.8457 70.3877L77.8569 70.9999H79.6936C82.3987 70.9999 84.5806 67.293 84.5806 62.7288C84.5806 58.1647 82.3876 54.4689 79.6936 54.4689Z",
    fill: "url(#paint14_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M77.635 71C80.334 71 82.522 67.2969 82.522 62.7289C82.522 58.1609 80.334 54.4578 77.635 54.4578C74.9361 54.4578 72.748 58.1609 72.748 62.7289C72.748 67.2969 74.9361 71 77.635 71Z",
    fill: "url(#paint15_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9449 67.3709C78.4635 67.3709 79.6946 65.2926 79.6946 62.7288C79.6946 60.1651 78.4635 58.0868 76.9449 58.0868C75.4264 58.0868 74.1953 60.1651 74.1953 62.7288C74.1953 65.2926 75.4264 67.3709 76.9449 67.3709Z",
    fill: "#F9FAFA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3569 67.037C78.6419 67.037 79.6835 65.1082 79.6835 62.7289C79.6835 60.3496 78.6419 58.4208 77.3569 58.4208C76.072 58.4208 75.0303 60.3496 75.0303 62.7289C75.0303 65.1082 76.072 67.037 77.3569 67.037Z",
    fill: "url(#paint16_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58077 10.8428C0.667943 10.9987 0 11.789 0 12.713V47.3113C0 48.3132 0.790384 49.1481 1.79227 49.2038L66.8144 52.8328V0.000244141L1.58077 10.8428Z",
    fill: "url(#paint17_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M103.473 1.23564L66.8037 0V52.8326H105.443V3.2728C105.443 2.17073 104.575 1.26903 103.473 1.23564Z",
    fill: "url(#paint18_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M53.0664 39.552C44.7174 35.7115 36.8804 41.578 29.2438 35.9007C22.5535 30.9358 24.7131 23.5664 19.3697 14.8612C18.1452 12.8685 16.5088 10.7757 14.2713 8.72742L1.58077 10.8425C0.667943 10.9983 0 11.7887 0 12.7127V47.311C0 48.3129 0.790384 49.1478 1.79227 49.2035L63.4637 52.6432C60.625 44.9065 56.7733 41.2552 53.0664 39.552Z",
    fill: "url(#paint19_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M124.979 36.1124L122.274 29.2996L122.196 23.6668L124.935 23.1213C125.202 23.0656 125.369 22.8096 125.302 22.5425C124.89 20.8838 123.376 15.3957 121.016 13.5812C119.358 12.301 87.8541 11.9225 87.8541 11.9225L72.6922 12.9133C71.5011 12.9912 70.5771 13.9819 70.5771 15.1731V48.7695C70.5771 49.6489 71.2562 50.3836 72.1245 50.4616L82.533 51.3632L84.5924 53.4449C84.5924 53.4449 114.092 55.8049 125.87 53.6565C126.482 53.5451 126.927 53.0219 126.927 52.3985V37.6152C126.916 35.4778 124.979 36.1124 124.979 36.1124Z",
    fill: "#FDFEFE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M92.9974 38.1607C92.9974 38.1607 92.6746 23.5666 92.9974 17.5553C93.1533 14.6387 91.695 12.9355 90.1476 11.9559C88.7116 11.9336 87.8433 11.9225 87.8433 11.9225L72.6815 12.9133C71.4904 12.9912 70.5664 13.9819 70.5664 15.1731V48.7695C70.5664 49.6489 71.2454 50.3836 72.1137 50.4616L82.5222 51.3632L84.5816 53.4449C84.5816 53.4449 89.4352 53.8346 96.0031 54.1574V41.7118L92.9974 38.1607Z",
    fill: "url(#paint20_linear)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M126.571 56.2724L125.402 55.8605V53.5005C125.402 52.866 124.89 52.3428 124.244 52.3428H87.7091C86.8297 52.3428 86.1172 53.0552 86.1172 53.9347V68.0612C86.1172 68.8404 86.7629 69.4638 87.5421 69.4304L126.66 67.9276C127.395 67.8942 127.974 67.2931 127.974 66.5584V58.2539C127.985 57.3633 127.417 56.5729 126.571 56.2724Z",
    fill: "#CDDCE7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M122.119 44.1384H100.456C99.721 44.1384 99.1532 44.7618 99.1978 45.4854L100.389 62.4951C100.445 63.3523 101.179 63.9979 102.025 63.9757L120.638 63.3412C121.451 63.3189 122.107 62.6733 122.174 61.8717L123.365 45.4965C123.432 44.7618 122.853 44.1384 122.119 44.1384Z",
    fill: "url(#paint21_linear)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M126.571 56.2723L125.402 55.8605V53.5005C125.402 52.9995 125.079 52.5654 124.634 52.4095L122.408 62.8625C122.14 64.1093 121.072 65.011 119.792 65.0666L102.715 65.7346C101.491 65.7791 100.377 65.0221 99.9766 63.8644L95.9913 52.3539H87.7091C86.8297 52.3539 86.1172 53.0663 86.1172 53.9457V68.0723C86.1172 68.8515 86.7629 69.4749 87.5421 69.4415L126.66 67.9387C127.395 67.9053 127.974 67.3042 127.974 66.5695V58.265C127.985 57.3633 127.417 56.5729 126.571 56.2723Z",
    fill: "#CDDCE7"
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8285 64.7772L93.7653 64.9776C91.2383 65.1001 89.0787 63.2076 88.8672 60.6918L88.7002 58.7214H96.8377C97.3832 58.7214 97.8285 59.1667 97.8285 59.7122V64.7772Z",
    fill: "url(#paint22_linear)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M124.033 59.5564L123.388 63.9758C123.388 63.9758 127.674 63.831 127.562 58.432L124.902 58.7215C124.456 58.766 124.1 59.1111 124.033 59.5564Z",
    fill: "url(#paint23_linear)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9212 38.3053C93.2755 38.3053 92.6299 38.0938 92.1067 37.7153L90.4369 36.4908C89.8023 36.0232 89.4238 35.2774 89.4238 34.487V24.7576C89.4238 24.2901 89.6242 23.8559 89.9804 23.5665C90.3367 23.2659 90.7931 23.1435 91.2495 23.2214L92.8859 23.4997H122.319L125.146 36.1123L124.813 37.7598H124.679L93.9657 38.3053C93.9545 38.3053 93.9434 38.3053 93.9212 38.3053ZM90.9823 23.5331C90.6929 23.5331 90.4146 23.6333 90.1919 23.8225C89.9136 24.0563 89.7578 24.4014 89.7578 24.7576V34.487C89.7578 35.1661 90.0806 35.8117 90.6372 36.2125L92.307 37.437C92.7857 37.7932 93.3646 37.9824 93.9768 37.9713L124.556 37.4258L124.824 36.1123L122.074 23.8225H92.8748L91.205 23.5331C91.1159 23.5331 91.0491 23.5331 90.9823 23.5331Z",
    fill: "#AEAAA2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M122.186 23.6668H92.8529L91.2165 23.3885C90.3593 23.2438 89.5801 23.9005 89.5801 24.7577V34.4871C89.5801 35.2218 89.9363 35.912 90.5263 36.3462L92.1961 37.5707C92.7082 37.9492 93.3316 38.1384 93.9661 38.1273L124.679 37.5818L124.98 36.1013L122.186 23.6668Z",
    fill: "url(#paint24_linear)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M103.951 20.2825H101.457C101.079 20.2825 100.778 20.5942 100.778 20.9615V22.0079C100.778 22.3864 101.09 22.687 101.457 22.687H103.951C104.329 22.687 104.63 22.3753 104.63 22.0079V20.9615C104.641 20.5942 104.329 20.2825 103.951 20.2825Z",
    fill: "#CDDCE7"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M118.612 20.2823H116.119C115.74 20.2823 115.439 20.5941 115.439 20.9614V22.0078C115.439 22.3863 115.751 22.6869 116.119 22.6869H118.612C118.991 22.6869 119.291 22.3752 119.291 22.0078V20.9614C119.291 20.5941 118.979 20.2823 118.612 20.2823Z",
    fill: "#CDDCE7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M113.013 30.5909C105.443 27.6966 98.3187 31.3033 95.0571 27.3737C94.1776 26.3051 93.8214 24.9915 93.7323 23.6668H92.8529L91.2165 23.3885C90.3593 23.2438 89.5801 23.9005 89.5801 24.7577V34.4871C89.5801 35.2218 89.9363 35.912 90.5263 36.3462L92.1961 37.5707C92.7082 37.9492 93.3316 38.1384 93.9661 38.1273L121.785 37.6375C118.646 33.4073 115.451 31.526 113.013 30.5909Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 5.73321,
    y1: 57.6238,
    x2: 99.1127,
    y2: 57.6238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#343264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 59.2926,
    y1: 60.9477,
    x2: 76.9453,
    y2: 60.9477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#343264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 10.3043,
    y1: 54.5591,
    x2: 15.3179,
    y2: 54.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312526"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 9.24781,
    y1: 54.5591,
    x2: 14.2615,
    y2: 54.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312526"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 14.1332,
    y1: 54.8978,
    x2: 10.2182,
    y2: 54.3708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00540541,
    stopColor: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 15.9902,
    y1: 55.4412,
    x2: 21.4834,
    y2: 55.4412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312526"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 14.8331,
    y1: 55.4414,
    x2: 20.3262,
    y2: 55.4414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312526"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 20.183,
    y1: 55.8123,
    x2: 15.8936,
    y2: 55.2349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00540541,
    stopColor: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 22.0605,
    y1: 55.8677,
    x2: 28.0583,
    y2: 55.8677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312526"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 20.7977,
    y1: 55.8674,
    x2: 26.7955,
    y2: 55.8674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312526"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 26.6398,
    y1: 56.273,
    x2: 21.9563,
    y2: 55.6425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00540541,
    stopColor: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 50.3883,
    y1: 59.914,
    x2: 58.0452,
    y2: 59.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312526"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 48.7754,
    y1: 59.9145,
    x2: 56.4323,
    y2: 59.9145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312526"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 56.2336,
    y1: 60.4313,
    x2: 50.2546,
    y2: 59.6264,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00540541,
    stopColor: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 74.8006,
    y1: 62.7331,
    x2: 84.5825,
    y2: 62.7331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312526"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 72.7411,
    y1: 62.7331,
    x2: 82.523,
    y2: 62.7331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#110F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312526"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 82.2697,
    y1: 63.3939,
    x2: 74.6313,
    y2: 62.3657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00540541,
    stopColor: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 55.2271,
    y1: 18.0753,
    x2: -43.5305,
    y2: 82.2485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#FDCC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#FCCA06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: 121.261,
    y1: 4.07406,
    x2: 46.3278,
    y2: 51.7238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD9909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3138,
    stopColor: "#FDCC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#D0A80B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: -0.00954014,
    y1: 30.6907,
    x2: 63.4508,
    y2: 30.6907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#FCCA06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: 70.5621,
    y1: 33.0339,
    x2: 96,
    y2: 33.0339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00540541,
    stopColor: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDFEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 99.2039,
    y1: 54.0525,
    x2: 123.382,
    y2: 54.0525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#343264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 95.5691,
    y1: 53.711,
    x2: 83.6567,
    y2: 95.2122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C606"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 125.066,
    y1: 62.1776,
    x2: 113.153,
    y2: 103.679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCC06"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6C606"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 89.5871,
    y1: 30.7522,
    x2: 124.98,
    y2: 30.7522,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#202122"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#343264"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/Truck.edbd70ffeb8de8ea3d1159e94070887b.svg";
export { ForwardRef as ReactComponent };